module.exports = __webpack_public_path__ + "81faded7bfad1425aab4abb2c418bfff.jpg";